export default {
  itemsPerPage: [
    {
      value: 20
    },
    {
      value: 50
    },
    {
      value: 100
    }
  ]
}



// WEBPACK FOOTER //
// ./src/vuestic-theme/vuestic-components/vuestic-datatable/data/items-per-page-definition.js